import React, { FC } from 'react';
import { Box, Grid, Typography } from '@mui/material';
import boddVariables from '../../../variables.module.scss';

interface IndicatorTileProps {
    label: string;
    value: string;
    image: React.ReactNode;
}

const IndicatorTile: FC<IndicatorTileProps> = ({ label, value, image }) => (
    <Grid
        data-testid="IndicatorTile"
        item
        xs={6}
        sx={{
            width: '100%',
            maxWidth: '100%',
        }}
    >
        <Box
            sx={{
                border: 2,
                borderColor: boddVariables.grey50,
                justifyContent: 'center',
                alignItems: 'center',
            }}
        >
            {image}
            <Typography
                sx={{
                    display: 'flex',
                    fontSize: '18px',
                    textAlign: 'center',
                    p: 1,
                    height: '56px',
                    lineHeight: 'normal',
                    alignItems: 'center',
                    justifyContent: 'center',
                }}
            >
                {label}
            </Typography>
            <Typography
                sx={{
                    fontSize: '22px',
                    fontWeight: 600,
                    fontFamily: 'Poppins',
                    textAlign: 'center',
                    pb: 2,
                }}
            >
                {value}
            </Typography>
        </Box>
    </Grid>
);

export default IndicatorTile;
